declare global {
  interface ImportMeta {
    glob(pattern: string, options: { eager: true }): Record<string, unknown>;
  }
}

const services = import.meta.glob('./services/**/*.ts', { eager: true });
const models = import.meta.glob('./models/**/*.ts', { eager: true });

export function getCompatModules(modulePrefix: string): Record<string, Record<string, unknown>> {
  const result: Record<string, Record<string, unknown>> = {};

  for (const [path, module] of Object.entries({ ...services, ...models })) {
    const normalizedPath = path.replace('./', `${modulePrefix}/`).replace(/\.ts$/, '');
    result[normalizedPath] = module as Record<string, unknown>;
  }

  return result;
}
